/****************************************************
 * Module Name:  customerFTPsettingsProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CustomerFTPsettingsProxy {
  static GetSingleCustomerFTPsettingsById = (customerId, callback) => {
    let params = {
      id: customerId,
    };
    restAPICall(
      Constants.MANAGER_URL + "/customerftp",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateCustomerFTPsettings = (CustomerFTPsetting, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/customerftp",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(CustomerFTPsetting),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getAllCustomerFTPDetails = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/customerftp/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getAllCustomerFTPDetailsMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/customerftp/detail/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getAllCustomerFTPPending = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/customerftp/pending",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getAllCustomerFTPPendingDetails = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/customerftp/pending/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getCustomerFTPDetailByID = (customerId, callback) => {
    let params = {
      id: customerId,
    };
    restAPICall(
      Constants.MANAGER_URL + "/customerftp/detail",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getCustomerFTPAvailable = (customerId, callback) => {
    let params = {
      customerid: customerId,
    };
    restAPICall(
      Constants.MANAGER_URL + "/customerftp/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}